import React, { Component } from "react";
import PropTypes from "prop-types";
import { Grid, Paper, Button, Avatar } from "@material-ui/core";
import TextField from "@mui/material/TextField";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import history from "../utility/history";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { loginEndPoint } from "../utility/Constants";

import { setUser } from "../utility/preferences";
export class Login extends Component {
  AdminUserId = "admin";
  AdminPassword = "admin";

  constructor(props) {
    super(props);
    this.state = {
      userName: "",
      password: "",
      open: false,
      err: false,
    };

    this.handleUserNameChange = this.handleUserNameChange.bind(this);
    this.handlePassChange = this.handlePassChange.bind(this);
    this.Login = this.Login.bind(this);
    this.callLoginApi = this.callLoginApi.bind(this);
  }

  nextPath(path) {
    console.log(path);
    history.push(path);
  }

  handleUserNameChange(event) {
    // this.state.userName = event.target.value;
    this.setState({ userName: event.target.value });
  }
  handlePassChange(event) {
    // this.state.password = event.target.value;
    this.setState({ password: event.target.value });
  }

  callLoginApi = () => {
    // console.log('callLoginApi');
    let userData = {};
    const response = fetch(loginEndPoint, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        username: this.state.userName,
        password: this.state.password,
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        // this.setState({ loginRes: res })
        this.setState({ loginRes: res });
        console.log("1", this.state.loginRes);
        // return res;

        // if(this.state.loginRes.res !== 'user not found')

        if (this.state.loginRes["error"] === 0) {
          //for testing...
          console.log(2, this.state.loginRes);
          setUser(this.state.loginRes["data"]);
          this.nextPath("/dashboard");
        } else {
          this.setState({ err: true });
          this.setState({ open: false });
          console.log(3, this.state.loginRes["res"]);
        }
      });
    console.log(response);
  };

  Login() {
    this.setState({ open: !this.state.open });
    this.callLoginApi();
  }

  render() {
    return (
      <div>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={this.state.open}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Grid
          container
          spacing={0}
          direction="column"
          alignItems="center"
          justifyContent="center"
          style={{ minHeight: "100vh" }}
        >
          {/* {this.state.loginCon && <Alert severity="info">This is an info alert — check it out!</Alert>} */}
          <Paper elevation={2} style={{ padding: "40px 50px" }}>
            <Grid item xs={12} align="center">
              <Avatar>
                <LockOutlinedIcon />
              </Avatar>
              <h3>Login</h3>
              <TextField
                margin="normal"
                id="userName"
                label="Username"
                placeholder="Enter username"
                variant="standard"
                fullWidth
                required
                error={this.state.err}
                onChange={this.handleUserNameChange}
              />
            </Grid>
            <Grid item xs={12} align="center">
              <TextField
                sx={{ mb: 5 }}
                margin="normal"
                id="userPass"
                label="Password"
                type="password"
                placeholder="Enter password"
                variant="standard"
                fullWidth
                required
                error={this.state.err}
                onChange={this.handlePassChange}
              />
            </Grid>
            {/* <FormControlLabel
                control={<Checkbox  />}
                label="Remember me"
                sx={{ mb: 4 }}
              /> */}

            <Grid item xs={12} align="center">
              <Button color="primary" variant="outlined" onClick={this.Login}>
                Login
              </Button>
            </Grid>
          </Paper>
        </Grid>
      </div>
    );
  }
}

export default Login;
